import React, { FC, useContext } from 'react';
import { Hotel } from '../../ts/interfaces/OphirResponse';
import Slider from 'react-slick';
import { getImgUrl } from '../../utils';
import { cdnUrl, soldOutImg } from '../../constants';

interface CarouselCardProps {
  hotel: Hotel;
  soldOut?: boolean;
}

const CarouselCard: FC<CarouselCardProps> = ({ hotel, ...props }) => {
  return (
    <div className="default-shadow oph-details-center">
      <div className="text-bold text-lg">
        <span className="name" dangerouslySetInnerHTML={{ __html: hotel.name }}></span>
      </div>

      <div className="position-relative">
        <Slider arrows={true} dots className="oph-details-slider">
          {hotel.allPhotos.map((image, index) => (
            <img key={index} src={getImgUrl(image.link, cdnUrl)} alt={image.alt} />
          ))}
        </Slider>
        {props.soldOut && (
          <img
            style={{ position: 'absolute', bottom: -100, left: 0, height: 'auto', width: 400 }}
            src={soldOutImg}
            alt="sold"
          />
        )}
      </div>
    </div>
  );
};

export default CarouselCard;
